import React, { Fragment } from 'react'
import { useStyles } from './styles'
import { PickingSquareColors } from '../../const/pickingReportConst'
import { PickingItemProps } from './interfaces'
import { usePickingReport } from '../../Context/usePickingReport'
import { Loading } from '../../../UI'

export const RoutesList = ({
  picking,
  routes
}: {
  picking: PickingItemProps
  routes: string[]
}) => {
  const classes = useStyles()

  const { state } = usePickingReport()
  return (
    <Fragment>
      {state.loading && (
        <div className={classes.routeslist}>
          <Loading />
        </div>
      )}

      {!state.loading && routes.length > 0 && (
        <div className={classes.routeslist}>
          <div
            style={{
              color: 'white',
              backgroundColor: PickingSquareColors.find(
                (element) => element.id === picking.id
              )?.color
            }}
          >
            <strong>{`${picking.qty} - ${picking.title}`}</strong>
          </div>
          <div style={{ overflowY: 'auto' }}>
            {routes.map((route, index) => (
              <p key={index}>{route}</p>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  )
}
